import { createContext, useContext } from 'react';

type NavigationGuardContextValue = {
  setHasUnsavedChanges: (hasUnsavedChanges: boolean) => void;
};

const NavigationGuardContext = createContext<NavigationGuardContextValue>({
  setHasUnsavedChanges: () => undefined,
});

export const NavigationGuardProvider = NavigationGuardContext.Provider;

export function useNavigationGuard(): NavigationGuardContextValue {
  return useContext(NavigationGuardContext);
}
